import { currencyFormate, formate } from "./utiil/Formate";
import MissingTimeEntries from "./MissingTimeEntries";

const Summary = ({ accounts, missingByCompany, trackingReady }) => {
    const accountList = Object.values(accounts);
    if (accountList.length === 0) return null;

    return (
        <div className="summary">
            {accountList.map(account => {
                const missingUsers = missingByCompany[account.id] || [];
                const missing = missingUsers.length;

                return (
                    <a key={account.id} className="summary-card" href={`#account-${account.id}`}>
                        <div className="summary-card-group">
                            <span className="summary-card-name">{account.name}</span>
                            <div className="summary-card-stats">
                                <span className="summary-stat-value">{formate(account.sum_hours)} t</span>
                                <span className="summary-stat-value">{currencyFormate(account.sum_amount)} kr</span>
                            </div>
                        </div>
                        {!trackingReady
                            ? <span className="summary-missing summary-missing--loading">…</span>
                            : missing > 0
                                ? <div onClick={e => e.preventDefault()}><MissingTimeEntries users={missingUsers} compact /></div>
                                : <span className="summary-missing summary-missing--ok">✓</span>
                        }
                    </a>
                );
            })}
        </div>
    );
};

export default Summary;
